<template>
  <div>
    <v-card class="elevation-0">
      <v-card-title>
        <h4 class="text-h6">
          <template v-if="$store.getters.locale === $store.state.secondaryLocale">{{ product.nameTranslated }}</template>
          <template v-else>{{ product.name }}</template>
        </h4>
      </v-card-title>
      <template v-if="product.description">
        <v-divider />
        <v-card-text>
          <div
            class="product-description"
          >
            <read-more-toggler
              :max-chars="300"
              :text="product.description"
            >
              <template v-slot:readMore>
                <v-btn
                  class="ml-n4"
                  color="primary"
                  dark
                  depressed
                  text
                >
                  <v-icon
                    size="12px"
                    class="mr-2"
                  >fal fa-plus</v-icon>
                  {{ $t('Show {0}', [$t('More')]) }}
                </v-btn>
              </template>
              <template v-slot:readLess>
                <v-btn
                  class="ml-n4"
                  color="primary"
                  dark
                  depressed
                  text
                >
                  <v-icon
                    size="12px"
                    class="mr-2"
                  >fal fa-minus</v-icon>
                  {{ $t('Show {0}', [$t('Less')]) }}
                </v-btn>
              </template>
            </read-more-toggler>
          </div>
        </v-card-text>
      </template>
      <v-divider />
      <v-card-text>
        <table
          width="100%"
          cellspacing="10"
        >
          <colgroup>
            <col width="30%">
            <col width="70%">
          </colgroup>
          <tr v-if="product.brand">
            <td class="font-weight-bold">{{ $t('Brand') }}</td>
            <td>{{ product.brand.name }}</td>
          </tr>
          <tr v-if="product.sku">
            <td class="font-weight-bold">{{ $t('SKU') }}</td>
            <td>{{ product.sku }}</td>
          </tr>
          <tr v-if="product.barcode">
            <td class="font-weight-bold">{{ $t('Barcode') }}</td>
            <td>{{ product.barcode }}</td>
          </tr>
          <tr>
            <td class="font-weight-bold">{{ $t('Price') }}</td>
            <td>
              <template v-if="product.retailPromo">
                {{ product.retailPromo | money }} <span class="font-strikethrough text-caption">{{ product.retailPrice | money }}</span>
              </template>
              <template v-else>
                {{ product.retailPrice | money }}
              </template>
            </td>
          </tr>
          <tr v-show="product.tags.length">
            <td class="font-weight-bold">{{ $t('Tags') }}</td>
            <td>
              <div
                class="d-flex flex-wrap"
                style="gap:5px 2.5px">
                <v-chip
                  v-for="tag in product.tags"
                  :key="tag.id"
                  :to="{ name: 'ProductsTag', params: { 'tag': tag.slug} }"
                  class="mr-1"
                  color="primary"
                  label
                  small
                  text-color="white"
                >
                  <v-icon
                    small
                    left
                  >fal fa-tag</v-icon>{{ tag.name }}
                </v-chip>
              </div>
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">{{ $t('Stock') }}</td>
            <td><stock-chip :value="_.get(product, 'storeStock.stock', 0)" /></td>
          </tr>
        </table>
      </v-card-text>
      <v-divider />
      <v-progress-linear
        v-show="$wait.is(`${product.id} adding to cart`)"
        :indeterminate="true"
        class="mt-0 mb-0"
        height="1"
      />
      <v-card-actions>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="ma-0"
              left
              text
              v-on="on"
              @click.stop="$emit('click:history', product)"
            >
              <v-icon
                small
                class="mr-2"
              >fal fa-calendar-alt</v-icon>
              {{ $t('Sales History') }}
            </v-btn>
          </template>
          <span>{{ $t('Sales History') }}</span>
        </v-tooltip>
        <v-spacer />
        <v-btn
          v-show="cashRegister.openedReport"
          :loading="$wait.is(`${product.id} adding to cart`)"
          class="ml-0"
          color="primary"
          dark
          depressed
          text
          @click="$emit('added-to-cart', product)"
        >
          <v-icon
            dark
            left
            small
          >far fa-shopping-basket</v-icon>
          {{ $t('Add to {0}', [$t('Cart').toLowerCase()]) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StockChip from '@/components/chips/StockChip'
import ReadMoreToggler from '@/components/ReadMoreToggler'

export default {
  name: 'ProductInfo',

  components: {
    ReadMoreToggler,
    StockChip
  },

  props: {
    productObject: {
      default: null,
      type: Object
    }
  },

  data: () => ({
    product: null
  }),

  computed: {
    ...mapState(['cashRegister'])
  },

  watch: {
    productObject: {
      immediate: true,
      handler (productObject) {
        this.product = Object.assign({}, productObject)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .product-description /deep/ p:last-child {
    margin-bottom: 0;
  }
  .v-chip /deep/ .v-chip__content {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/products/ProductInfo.vue